import { apiClient } from '~/lib/apiClient';
import type { Team } from '~/stores/useTeamStore';

export interface SettingsProfile {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  isSuperAdmin?: boolean;
}

export async function resolveAccessibleTeams(): Promise<Team[]> {
  const memberData = await apiClient.get<{ userTeams?: Team[] }>('/team');
  return memberData.userTeams || [];
}

export function mapSettingsToUser(profile: SettingsProfile) {
  return {
    id: profile.id || 0,
    firstName: profile.firstName,
    lastName: profile.lastName,
    email: profile.email,
    isSuperAdmin: !!profile.isSuperAdmin,
  };
}
